export const APP_INFO = {
  name: 'Rahmani30',
  version: '1.0.0',
  description: 'Rahmani30 - transparent donation management platform',
  organization: 'Rahmani30',
  contact: {
    email: 'togetherwerise@rahmanimission.org',
    phone: '9740755800',
  },
} as const;

export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'https://rahmani30-collaborate-api.rahmani30reactapp.workers.dev/api',
  timeout: 30000,
} as const;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  PROJECTS: '/projects',
  PROJECT_DETAIL: '/projects/:id',
  DONATIONS: '/donations/my-donations',
  DONATE: '/projects/:projectId/donate',
  DONATE_GENERAL: '/donate',
  SUBSCRIPTIONS: '/my-subscriptions',
  RECEIPTS: '/receipts',
  AMBASSADOR: '/ambassador',
  ADMIN: {
    DASHBOARD: '/admin',
    USERS: '/admin/users',
    DONATIONS: '/admin/donations',
    AMBASSADORS: '/admin/ambassadors',
    ALUMNI_REQUESTS: '/admin/alumni-requests',
  },
} as const;

export const USER_ROLES = {
  USER: 'USER',
  ADMIN: 'ADMIN',
} as const;

export const PROJECT_STATUS = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  PAUSED: 'PAUSED',
  CANCELLED: 'CANCELLED',
} as const;

export const PAYMENT_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
} as const;

export const PAGINATION = {
  defaultPageSize: 10,
  pageSizeOptions: [10, 20, 50, 100],
} as const;

export const TOAST_CONFIG = {
  duration: 3000,
  position: 'top-right' as const,
} as const;
